// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"hB","image":"hC","contentContainer":"hD","mainText":"hE","subText":"hF","counter":"hG","button":"hH"};